export default __webpack_public_path__ + "static/media/avatarred.8c8bbbaf.svg";